<div class="raptor-page-container">
  <open-raptor-progress *ngIf="!(formData.settings && formData.settings.hide_progress_bar)" [progress]="formData.progress" [pages]="formData.total_pages"></open-raptor-progress>
  <open-raptor-banner-header *ngIf="bannerHeaders" [data]="bannerHeaders"></open-raptor-banner-header>
  <div class="grid" *ngIf="formData.actions && formData.actions.back">
    <div class="cell margin-right-medium margin-left-xmedium progress-nav">
      <button mat-icon-button color="primary" type="reset" [disabled]="raptorStepService.loading"><mat-icon>west</mat-icon></button>
    </div>
  </div>

  <div class="raptor-page-content padding-bottom-big" *ngIf="raptorStepService.stepReady" [class]="pageClass" [ngClass]="{'padding-top-big': !formData.actions || !formData.actions.back}">
    <div class="raptor-page-panel" [class]="raptorStepService.action" *ngIf="layoutSettings">
      <div class="grid">
        <div
          class="raptor-page-main-panel cell cell-small-col-span-6"
          [ngClass]="{ 'cell-large-col-span-8': layoutSettings.sidebar, 'cell-large-col-span-10 cell-large-col-start-2': !layoutSettings.sidebar && layoutSettings.size !== 'large', 'cell-large-col-span-12': !layoutSettings.sidebar && layoutSettings.size === 'large' }"
        >
          <header class="padding-horizontal-medium margin-bottom-xsmall">
            <div class="grid">
              <div class="cell cell-large-col-span-12" [ngClass]="{'cell-medium-col-span-7': layoutSettings.align === 'left'}">
                <h1 *ngIf="formData.heading" [ngClass]="{'text-center': layoutSettings.align === 'center', 'margin-bottom-medium': formData.subtext}">{{ formData.heading }}</h1>
                <div
                  *ngIf="formData.subtext"
                  [innerHTML]="formData.subtext"
                  class="raptor-page-subtext"
                  [ngClass]="{
                    'text-left': !layoutSettings.align || layoutSettings.align === 'left',
                    'text-center': layoutSettings.align === 'center',
                    'text-right': layoutSettings.align === 'right'
                  }"
                ></div>
              </div>
            </div>
          </header>

          <!-- MAIN CONTENT -->
          <div class="raptor-page-column-container grid">
            <div class="raptor-page-column-content cell cell-small-col-span-6" [ngClass]="layoutStructure">
              <div *ngIf="formData.info && formData.info.settings && formData.info.settings.align === 'top'" class="margin-bottom-small">
                <open-raptor-info [info]="formData.info" [form]="form"></open-raptor-info>
              </div>

              <div *ngFor="let section of formData.sections" class="form-row">
                <open-raptor-section [section]="section" [form]="form"></open-raptor-section>
              </div>

              <div *ngIf="formData.info && (!formData.info.settings || (formData.info.settings.align !== 'top' && formData.info.settings.align !== 'below'))" class="margin-horizontal-medium">
                <open-raptor-info [info]="formData.info" [form]="form"></open-raptor-info>
              </div>
            </div>
          </div>

          <!-- ERRORS - show errors in FormData -->
          <div *ngIf="formData.errors" class="open-form-info is-error padding-medium margin-bottom-medium">
            <b>Error on page</b>

            <div>
              <ng-container *ngFor="let errorItem of formData.errors">
                <ng-container *ngFor="let element of errorItem | keyvalue">
                  <p *ngIf="element.key === 'label'">{{ element.value }}</p>

                  <ul *ngIf="element.key === 'messages'">
                    <li *ngFor="let message of getErrorMessages(element.value)" [innerHTML]="message"></li>
                  </ul>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <div class="raptor-form-action" [ngClass]="{'tile-spacing': endsWithTiles === true}">
            <!-- <pre>form valid: {{ form.valid }}</pre> -->
            <button *ngIf="!(formData.settings && formData.settings.hide_cta)" mat-flat-button color="primary" type="submit" [disabled]="submitDisabled">
              <span *ngIf="!raptorStepService.loading">{{ submitLabel }}</span>
              <mat-spinner *ngIf="raptorStepService.loading" diameter="28"></mat-spinner>
            </button>

            <div [class]="!(formData.settings && formData.settings.hide_cta) ? 'margin-top-small' : ''" *ngIf="formData.actions && formData.actions.jumps && formData.actions.jumps.default">
              <a mat-button color="primary" (click)="jump(formData.actions.jumps.default)" [disabled]="formData.settings.disable_cta || raptorStepService.loading" type="button">{{ formData.actions.jumps.default.label }}&nbsp;<mat-icon class="material-symbols-outlined undo" iconPositionEnd></mat-icon></a>
            </div>
          </div>

          <!-- BELOW CTA CONTENT -->
          <div class="raptor-page-column-container grid" *ngIf="formData.info && formData.info.settings && formData.info.settings.align === 'below'">
            <div class="raptor-page-column-content cell cell-small-col-span-6" [ngClass]="layoutStructure">
              <div class="margin-top-xmedium">
                <open-raptor-info [info]="formData.info" [form]="form"></open-raptor-info>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="layoutSettings.sidebar" class="raptor-page-sidebar-panel cell cell-small-col-span-6 cell-large-col-span-4">
          <open-raptor-sidebar [sidebar]="layoutSettings.sidebar" [form]="form"></open-raptor-sidebar>
        </div>
      </div>

    </div>

  </div>

  <open-raptor-banner-footer *ngIf="bannerFooters" [data]="bannerFooters"></open-raptor-banner-footer>

</div>

<!-- cover disclaimers -->
<div class="raptor-page-default-disclaimers">
  <div class="grid grid-wrapper mat-typography margin-top-medium" *ngIf="!raptorStepService.loading && disclaimers">
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">
      <div *ngFor="let disclaimer of disclaimers | orderBy: 'type': 'desc'; index as i">
        <div *ngIf="disclaimer.type === 'promotional'" class="raptor-page-banner text-xsmall" [ngClass]="{'margin-bottom-xsmall':i < disclaimers.length - 1}">
          {{ disclaimer.content }}
        </div>
        <!-- Showing extras banners at the bottom in order to list the included extras disclaimers that accompany this specific disclaimer -->
        <div *ngIf="disclaimer.type === 'additionalCharges' && formData.sidebar" class="raptor-page-banner text-xsmall" [ngClass]="{'margin-bottom-xsmall':i < disclaimers.length - 1}">
          {{ disclaimer.content }}
        </div>
        <div *ngIf="disclaimer.type === 'banner'" class="raptor-page-banner text-xsmall" [ngClass]="{'margin-bottom-xsmall':i < disclaimers.length - 1}" [innerHTML]="disclaimer.content">
        </div>
      </div>
      <ul class="margin-bottom-none" *ngIf="includedExtrasDisclaimers?.length && formData.sidebar">
        <li class="raptor-page-banner text-xsmall" *ngFor="let extrasDisclaimer of includedExtrasDisclaimers"><strong>{{ extrasDisclaimer.label }}:</strong> {{ extrasDisclaimer.disclaimer }}</li>
      </ul>
    </div>
  </div>

  <!-- Page disclaimer -->
  <div class="grid grid-wrapper mat-typography margin-top-medium" *ngIf="!raptorStepService.loading && formData.disclaimer && formData.disclaimer.content">
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">
      <div class="raptor-page-banner margin-bottom-none text-xsmall" [innerHTML]="formData.disclaimer.content"></div>
    </div>
  </div>
</div>
